import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from 'reactstrap';
import classnames from 'classnames';
import { ToastContainer } from 'react-toastify';
import AwardingTable from './AwardingTable';
import CreateAwardingModal from './CreateAwardingModal';
import useAwardingApi from '../hooks/useAwardingApi';
import {
  PROCUREMENT_TYPE_HEADER,
  unwrapAwardingDetail,
} from '../utils/awardingHelpers';

const TABS = [
  {
    id: 'product-hydro',
    label: 'Product Hydro',
    icon: 'ri-gas-station-line',
    procurementTypeHeader: PROCUREMENT_TYPE_HEADER.productHydro,
  },
  {
    id: 'hydrocarbon-condensat',
    label: 'Hydrocarbon & Condensate',
    icon: 'ri-oil-line',
    procurementTypeHeader: PROCUREMENT_TYPE_HEADER.hydroCondensate,
  },
];

const AwardingList = ({
  endpoint = '/awarding',
  detailBasePath = '/apps-awarding/dtl',
  canCreate = true,
  title = 'Awarding',
}) => {
  const navigate = useNavigate();
  const { createAwarding } = useAwardingApi();
  const [activeTab, setActiveTab] = useState('product-hydro');
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleCreate = () => setIsCreateOpen(prev => !prev);

  const handleNext = async draft => {
    setIsSubmitting(true);
    try {
      const result = await createAwarding({
        procurementNumber: draft.procurementNumber,
        procurementTypeHeader: Number(draft.procurementTypeHeader),
        titleProcurement: draft.titleProcurement,
        procurementType: draft.procurementType,
        description: draft.description,
      });

      const created = unwrapAwardingDetail(result);
      if (!created?.id) {
        toast.error('Awarding created but no identifier returned');
        return;
      }

      setIsCreateOpen(false);
      navigate(`/apps-awarding/dtl/${created.id}`);
    } catch (error) {
      toast.error(error.message || 'Failed to create awarding');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} limit={1} />

      <Row>
        <Col lg={12}>
          <Card className='shadow-none border'>
            <CardBody className='p-4'>
              <Row className='align-items-start mb-3'>
                <Col>
                  <h4 className='fw-bold mb-1'>{title}</h4>
                  <p className='text-muted fs-13 mb-0'>
                    Bisa jadi Kalimat tambahan untuk membantu section mengenai
                    apa ini
                  </p>
                </Col>
                {canCreate && (
                  <Col xs='auto'>
                    <Button color='primary' onClick={toggleCreate}>
                      Create Awarding
                      <i className='ri-add-line align-bottom ms-1'></i>
                    </Button>
                  </Col>
                )}
              </Row>

              <Nav tabs className='nav-tabs-custom nav-primary mb-0'>
                {TABS.map(tab => (
                  <NavItem key={tab.id}>
                    <NavLink
                      className={classnames('cursor-pointer', {
                        active: activeTab === tab.id,
                      })}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <i className={`${tab.icon} align-middle me-1`}></i>
                      <span className='fw-semibold'>{tab.label}</span>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <TabContent activeTab={activeTab} className='pt-3'>
                {TABS.map(tab =>
                  activeTab === tab.id ? (
                    <TabPane key={tab.id} tabId={tab.id}>
                      <AwardingTable
                        procurementTypeHeader={tab.procurementTypeHeader}
                        endpoint={endpoint}
                        detailBasePath={detailBasePath}
                      />
                    </TabPane>
                  ) : null
                )}
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {canCreate && (
        <CreateAwardingModal
          isOpen={isCreateOpen}
          toggle={toggleCreate}
          onNext={handleNext}
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default AwardingList;
